var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{ref:"app",staticClass:"primary",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"app"}},[_c('v-main',[_c('router-view')],1),_c('click-audio')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }